import { Injectable } from '@angular/core';
import { Energieart } from '../../domain/model/energieart';

@Injectable({
    providedIn: 'root',
})
export class EnergieartColorService {

    public static readonly DEFAULT_COLOR = 'galvanic-green-dark';
    public static readonly COLOR_WATER = 'iridescent-indigo-muted';
    public static readonly COLOR_WIND = 'blazing-blue-muted';
    public static readonly COLOR_BHKW = 'fiery-fuchsia-muted';
    public static readonly COLOR_PHOTOVOLTAIC = 'pulsing-purple-muted';
    public static readonly COLOR_BIO = 'galvanic-green-muted';

    public getColorNameForEnergieart(energieart: Energieart): string {
        switch (energieart) {
            case Energieart.WIND:
                return EnergieartColorService.COLOR_WIND;
            case Energieart.GASE_BIOMASSE:
                return EnergieartColorService.COLOR_BIO;
            case Energieart.WASSER:
                return EnergieartColorService.COLOR_WATER;
            case Energieart.SOLAR:
                return EnergieartColorService.COLOR_PHOTOVOLTAIC;
            case Energieart.BHKW:
                return EnergieartColorService.COLOR_BHKW;
            case Energieart.GEOTHERMIE:
                return EnergieartColorService.COLOR_BIO;
        }
        return EnergieartColorService.DEFAULT_COLOR;
    }
}
